import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import config from "../../Config";
import Examination_navbar from "./Examination_navbar";
import SessionsDropDown from "../Shared/SessionsDropDown";
import { scrollToTop } from "../Shared/ScrollOnTop";

function ManageResultCards() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [SessionID, setSessionID] = useState(
    parseInt(localStorage.getItem("DefaultSession"), 10) || 0
  );
  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState([]);
  const [isUpdated, setIsUpdated] = useState(false);

  useEffect(() => {
    document.title = "Manage Result Cards";
    if (!SessionID) {
      return;
    }

    setIsUpdated(false);
    setLoading(true);

    axios({
      method: "post",
      url: config.base_url + "ResultCard/GetResultCards",
      headers: { "Content-Type": "application/json" },
      data: { AccessKey, UserID, MemberType, SessionID },
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          setRecords(response.data.ListofRecords || []);
        } else {
          setRecords([]);
          if (response.data.status_message) {
            toast.error(response.data.status_message);
          }
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        toast.error("Network error.");
      });
  }, [SessionID, isUpdated]);

  const deleteCard = (id) => {
    if (!window.confirm("Delete this result card?")) {
      return;
    }

    axios({
      method: "post",
      url: config.base_url + "ResultCard/DeleteResultCard",
      headers: { "Content-Type": "application/json" },
      data: { AccessKey, UserID, MemberType, ID: id },
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          toast.success(response.data.status_message);
          setIsUpdated(true);
        } else {
          toast.error(response.data.status_message || "Delete failed.");
        }
      })
      .catch(() => toast.error("Network error."));
  };

  const renderRows = () => {
    if (records.length === 0) {
      return (
        <tr>
          <td colSpan="9">
            <h4
              className="mt-3"
              style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
            >
              No result cards found
            </h4>
          </td>
        </tr>
      );
    }

    let count = 1;
    return records.map((item) => (
      <tr key={item.ID}>
        <td>{count++}</td>
        <td>{item.ResultCard_Code}</td>
        <td>{item.Title}</td>
        <td>{item.Print_Title}</td>
        <td>{item.Result_Type}</td>
        <td>{item.Grade_Scale_Type}</td>
        <td>{item.ComponentCount}</td>
        <td>
          {item.Is_Published ? (
            <>
              Yes
              {item.Published_Date
                ? ` (${moment(item.Published_Date).format("DD/MM/YYYY")})`
                : ""}
            </>
          ) : (
            "No"
          )}
        </td>
        <td className="text-center">
          <div className="dropdown dropdown-table-actions">
            <Link
              to="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              onClick={(e) => e.preventDefault()}
            >
              <i className="ri-more-fill"></i>
            </Link>
            <ul className="dropdown-menu dropdown-menu-end">
              <li>
                <Link
                  to={`/ExaminationSystem/EditResultCard/${item.ID}`}
                  className="dropdown-item"
                  onClick={scrollToTop}
                >
                  <i className="ri-edit-line"></i> Edit
                </Link>
              </li>
              <li>
                <Link
                  to={`/ExaminationSystem/PublishResultCard?ID=${item.ID}`}
                  className="dropdown-item"
                  onClick={scrollToTop}
                >
                  <i className="ri-upload-cloud-line"></i> Publish
                </Link>
              </li>
              <li>
                <Link
                  to={`/ExaminationSystem/PrintPublishedResultCard?ID=${item.ID}`}
                  className="dropdown-item"
                  onClick={scrollToTop}
                >
                  <i className="ri-printer-line"></i> Print Published
                </Link>
              </li>
              <li>
                <button
                  type="button"
                  className="dropdown-item"
                  onClick={() => deleteCard(item.ID)}
                >
                  <i className="ri-delete-bin-line"></i> Delete
                </button>
              </li>
            </ul>
          </div>
        </td>
      </tr>
    ));
  };

  return (
    <>
      <Examination_navbar />
      <ToastContainer />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/Dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/ExaminationSystem/ExaminationDashboard">
                      Examinations
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Result Cards
                  </li>
                </ol>
              </nav>
              <div className="page-title">Manage Result Cards</div>
            </div>
            <div className="col-md-6">
              <div className="page-right-actions d-flex gap-2 justify-content-md-end">
                <Link
                  to="/ExaminationSystem/ExaminationGuidelines"
                  className="button button-white button-icon"
                  onClick={scrollToTop}
                >
                  Guidelines
                  <i className="ri-book-open-line"></i>
                </Link>
                <Link
                  to="/ExaminationSystem/AddResultCard"
                  className="button button-white button-icon"
                  onClick={scrollToTop}
                >
                  Add Result Card
                  <i className="ri-add-line"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-content">
        <div className="container">
          <div className="card mb-3">
            <div className="card-body">
              <div className="row align-items-end">
                <div className="col-md-4">
                  <label>Session</label>
                  <select
                    className="form-select"
                    value={SessionID}
                    onChange={(e) =>
                      setSessionID(parseInt(e.target.value, 10) || 0)
                    }
                  >
                    <option value="">Please Select</option>
                    <SessionsDropDown />
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              <table className="table table-theme table-hover">
                <thead>
                  <tr>
                    <th>Sr.</th>
                    <th>Code</th>
                    <th>Title</th>
                    <th>Print Title</th>
                    <th>Type</th>
                    <th>Grade Scale</th>
                    <th>Components</th>
                    <th>Published</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="9" className="text-center">
                        <Spinner animation="border" role="status" />
                      </td>
                    </tr>
                  ) : (
                    renderRows()
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ManageResultCards;
